import { render } from "./FechaVence.vue?vue&type=template&id=0a1fa68c&scoped=true"
import script from "./FechaVence.vue?vue&type=script&lang=js"
export * from "./FechaVence.vue?vue&type=script&lang=js"

import "./FechaVence.vue?vue&type=style&index=0&id=0a1fa68c&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a1fa68c"]])

export default __exports__